<template>
  <div class="order-page">
    <el-card class="box-card">
      <!-- el-form -->

      <el-form :data="form"
               label-width="100px"
               style="width: 100%">
        <el-row :gutter="20">
          <el-row>
            <el-col :span="6">
              <el-form-item label-width
                            prop="buyer_nick"
                            label="昵称">
                <el-input v-model="form.buyer_nick"
                          style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="gender"
                            label="性别">
                <el-select v-model="form.gender"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option label="男"
                             value="男"></el-option>
                  <el-option label="女"
                             value="女"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label-width
                            prop="mobile"
                            label="手机">
                <el-input v-model="form.mobile"
                          style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="age"
                            label="年龄">
                <!-- <el-input v-model="form.age"></el-input> -->
                <number-range v-model="form.age" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="from"
                            label="客户来源">
                <el-input v-model="form.from"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label-width
                            prop="level"
                            label="会员等级">
                <!-- <el-input v-model="form.level"></el-input> -->
                <number-range v-model="form.level" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-show="searchAreaStatus">
            <el-col :span="6">
              <el-form-item label-width
                            prop="td"
                            label="营销短信退订">
                <!-- <el-input v-model="form.td"></el-input>
                -->
                <el-select v-model="form.td"
                           placeholder="请选择">
                  <el-option label="Y"
                             value="Y"></el-option>
                  <el-option label="N"
                             value="N"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="platCode"
                            label="行业">
                <el-select clearable
                           v-model="form.profession"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in platlists"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="business"
                            label="商家">
                <el-select v-loading="ptnListLoading"
                           clearable
                           v-model="form.business"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in ptnlists"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="store"
                            label="店铺">
                <el-select v-loading="shopListLoading"
                           clearable
                           v-model="form.store"
                           placeholder="请选择"
                           style="width: 100%">
                  <el-option v-for="item in shoplists"
                             :key="item.id"
                             :label="item.name"
                             :value="item.code">{{ item.name }}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width
                            prop="birthday"
                            label="生日">
                <!-- <el-input v-model="form.birthday"></el-input> -->
                <el-date-picker v-model="form.birthday"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <!-- <el-row>
        <el-col :span="12">
          <el-button @click="handleExport" type="primary" size="medium">导出</el-button>
          <el-button @click="handleImport" type="primary" size="medium">导入</el-button>
          <el-button @click="handleSearch" size="medium">搜索</el-button>
          <el-button @click="clearSearch" size="medium">重置</el-button>
          <el-button @click="searchAreaStatus = !searchAreaStatus">
            {{
            searchAreaStatus ? "收起" : "展开"
            }}
          </el-button>
        </el-col>
      </el-row>-->
      <action-line @action-line="handleActionLine"
                   :list="Desc.actionLine">
        <el-button @click="searchAreaStatus = !searchAreaStatus">{{ searchAreaStatus ? "收起" : "展开" }}</el-button>
      </action-line>
    </el-card>

    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              border
              :data="tableData">
      <!-- <el-table-column prop="字段英文名" align="center" header-align="center" label="字段中文名"></el-table-column> -->
      <el-table-column prop="buyer_nick"
                       align="center"
                       header-align="center"
                       label="昵称"></el-table-column>
      <el-table-column prop="gender"
                       align="center"
                       header-align="center"
                       label="性别"></el-table-column>
      <el-table-column prop="birthday"
                       align="center"
                       header-align="center"
                       label="生日"></el-table-column>
      <el-table-column prop="age"
                       align="center"
                       header-align="center"
                       label="年龄"></el-table-column>
      <el-table-column prop="mobile"
                       align="center"
                       header-align="center"
                       label="手机"></el-table-column>
      <el-table-column prop="from"
                       align="center"
                       header-align="center"
                       label="客户来源"></el-table-column>
      <el-table-column prop="level"
                       align="center"
                       header-align="center"
                       label="会员等级"></el-table-column>
      <el-table-column prop="td"
                       align="center"
                       header-align="center"
                       label="营销短信退订"></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="profession"
                       label="行业"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="business"
                       label="商家"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center"
                       header-aligin="center"
                       prop="store"
                       label="店铺"
                       min-width="110px"
                       show-overflow-tooltip></el-table-column>
    </el-table>
    <el-card>
      <el-row class="pagation-row">
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="queryPrdlists.pagenum"
                       :page-size="queryPrdlists.pagesize"
                       :page-sizes="[10, 20, 50, 100]"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total"></el-pagination>
      </el-row>
    </el-card>
    <import-dialog @submit="handleFile"
                   ref="refImportDialog" />
    <export-dialog ref="refExportDialog"
                   @submit="exportSubmit" />
  </div>
</template>

<script>
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import handleExport from '@/common/mixins/handle-export'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
import ImportDialog from '@/base/importDialog'
// import ActionLine from "@/base/action-line";
export default {
  mixins: [ActionLine, SearchMixin, handleExport],
  components: {
    ImportDialog,
    // ActionLine,
  },
  data() {
    return {
      form: {},
      loading: false,
      tableData: [],
      Desc,
      importForm: {
        input_file: null,
        input_method: 'Base',
      },
    }
  },
  created() {
    // this.getTableData();
  },
  methods: {
    // 公共代码 会在searchMixin
    // handleActionLine(handler) {
    //   this[handler] && this[handler]();
    // },
    // 也可以作为公共函数
    // async getTableData() {
    //   this.loading = true;
    //   let { data, err } = await this.axiosApi(
    //     Desc.list_api,
    //     this.queryPrdlists
    //   );
    //   // console.log("data", data);
    //   this.loading = false;
    //   this.tableData = data.data.data.data;
    //   this.total = parseInt(data.data.data.total);
    //   dealReturn(data, err);
    // },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/base/memberinfo/index.vue